export const APP_NAME = "Lorier";
